import { AuthenticatedUser, FlightRoomUser, FlightRoomUserStatus, JobTitle } from '@connect-x-app/shared-domain-models';
import { IconName } from '@connect-x-app/shared-types';

const getIconForOccupation = (input?: JobTitle): IconName => {
  switch (input) {
    case JobTitle.COMM:
    case JobTitle.COPILOT:
    case JobTitle.PILOT:
      return 'rolePilotCapOutline';
    case JobTitle.SCCM:
    case JobTitle.CCM:
    case JobTitle.CABIN_CREW:
    case JobTitle.ACM:
      return 'seatbeltOutline';
    case JobTitle.GH:
    case JobTitle.DISPATCHER:
    case JobTitle.GROUND_HANDLER:
      return 'roleDispatcherHeadsetOutline';
    case JobTitle.MAINTENANCE_CREW:
      return 'roleMaintenanceGogglesOutline';
    case JobTitle.DEADHEAD:
    case JobTitle.ADMINISTRATOR:
    case JobTitle.GUEST:
    case JobTitle.UNKNOWN:
    default:
      return 'roleDefault';
  }
};

export const getIconForUser = ({
  crewMember,
  user,
}: {
  crewMember?: FlightRoomUser;
  user?: AuthenticatedUser | FlightRoomUser | null;
}) => {
  if (crewMember?.status === FlightRoomUserStatus.SCHEDULED) {
    return getIconForOccupation(crewMember.jobTitle);
  }
  return getIconForOccupation(crewMember?.jobTitle ?? user?.jobTitle);
};
